<template>
  <v-container>
    <v-row>
      <v-col
        class="pointer-on-hover"
        @click="status = status == 'not_started' ? '' : 'not_started'; $emit('input', status)"
      >
        <div
          class="pl-2 btn_status"
          :class="{ 
            'bg-gray-dark': status == 'not_started',
            'font-12' : isMobile,
            'py-3': !isMobile,
            'py-1': isMobile,
          }"
        >
          A iniciar  
        </div>
        <v-progress-linear value="0" />
      </v-col>
      <v-col
        class="pointer-on-hover"
        @click="status = status == 'is_started' ? '' : 'is_started'; $emit('input', status)"
      >
        <div
          class="pl-2 btn_status"
          :class="{ 
            'bg-gray-dark': status == 'is_started',
            'font-12' : isMobile,
            'py-3': !isMobile,
            'py-1': isMobile,
          }"
        >
          Em andamento
        </div>
        <v-progress-linear value="50" />
      </v-col>
      <v-col
        class="pointer-on-hover"
        @click="status = status == 'finished' ? '' : 'finished'; $emit('input', status)"
      >
        <div
          class="pl-2 btn_status"
          :class="{ 
            'bg-gray-dark': status == 'finished',
            'font-12' : isMobile,
            'py-3': !isMobile,
            'py-1': isMobile,
          }"
        >
          Finalizado
        </div>
        <v-progress-linear value="100" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data(){
    return {
      status: ''
    }
  },
}
</script>
<style scoped lang="scss">
 .btn_status{
    border-radius: 5px 5px 0px 0px; 
    font-size: 16px;
    padding-left: 16px;
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    &:hover{
      background-color: #F1F2F7;
    }
 }
 
</style>